import { CheckCircleOutlined } from "@ant-design/icons";
import { Alert, Flex, Image } from "antd";
import defaultLogo from "assets/paldock_logo-auth.svg";
import { useAuthLayout } from "components/Layouts/AuthLayout/AuthLayoutContext.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { FC, ReactNode } from "react";

interface RegistrationSuccessProps {
    message?: string;
    icon?: ReactNode;
    alertType?: "info" | "warning";
}

export const RegistrationSuccess: FC<RegistrationSuccessProps> = ({ message, icon, alertType = "info" }) => {
    const { t } = usePaldockTranslation("ui.registration-success");
    const { logo } = useAuthLayout();

    return (
        <div className={"flex flex-col content-center align-center items-center gap-y-6 mb-4 w-full"}>
            <Flex justify="center" className="my-4">
                <Image src={logo ?? defaultLogo} width="75%" preview={false} alt="Logo" />
            </Flex>
            <div className={"text-center"}>
                {icon ?? <CheckCircleOutlined style={{ fontSize: "167px", color: "#008080" }} />}
            </div>
            <Alert
                type={alertType}
                showIcon
                message={message ?? t("message")}
                className={"w-full"}
                style={{ border: "none", boxShadow: "0px 3px 6px -4px #0000001F" }}
            />
        </div>
    );
};
